import { ReactComponent as Ldz02Logo } from 'assets/icons/ldz02Logo-full.svg'
import ConsentPreviewPopup from 'components/popups/ConsentPreview'
import { selectConfig, selectConfigContact } from 'appSlice'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import { useReduxSelector } from 'store'
import React from 'react'
import './style.scss'

const type = process.env.REACT_APP_TYPE
const today = new Date()

const Footer: React.FC = () => {
  const config = useReduxSelector(selectConfig)
  const contact = useReduxSelector(selectConfigContact)
  const { popup, openPopup } = usePopupState<{ type: 'terms' | 'privacy' }>()

  const { t } = useTranslation('basic')
  const { goBack } = useHistory()

  if (!contact) return null
  return (
    <>
      {(popup?.type === 'terms' || popup?.type === 'privacy') && <ConsentPreviewPopup
        type={popup.type}
        close={goBack}
      />}

      <div className='footer__wrapper'>
        <div className='footer'>
          <div className='footer__top'>
            <div className='footer__logo'>
              {type === 'mm'
                ? <>
                  <i className='icon icon--logo' />
                  <span className='--secFont'>Magazynomaty</span>
                </>
                : type === 'ldz01'
                  ? <>
                    <i className='icon icon--logo' />
                    <span className='--secFont'>VIP-BOX</span>
                  </>
                  : type === 'ldz02'
                    ? <Ldz02Logo />
                    : <i className={`icon icon--${type}-full-logo`} />}
            </div>

            <div className='footer__top__section'>
              <h4>{t('contact')}</h4>
              <div className='footer__top__section__list'>
                <p>
                  <a
                    title={t('writeAMessage')}
                    href={`mailto:${contact.email}`}>
                    {contact.email}
                  </a>
                </p>
                <p>
                  <a
                    title={t('callUs')}
                    href={`tel:${contact.phone}`}>
                    tel. {contact.phone}
                  </a>
                </p>
              </div>
            </div>

            <div className='footer__top__section'>
              <h4>{t('company')}</h4>
              <div className='footer__top__section__list'>
                <p>{contact.companyName}</p>
                <p>{contact.companyAddress}</p>
                <p>NIP: {contact.companyNip}</p>
                {contact.companyRegon && <p>REGON: {contact.companyRegon}</p>}
                {contact.companyKrs && <p>KRS: {contact.companyKrs}</p>}
              </div>
            </div>

            {config?.socials && <div className='footer__top__section'>
              <h4>{t('socialMedia')}</h4>
              <div className='footer__socials'>
                {config.socials?.facebook && <i
                  className='icon icon--facebook s32'
                  onClick={() => {
                    window.open(config.socials?.facebook)
                  }}
                />}
                {config.socials?.instagram && <i
                  className='icon icon--instagram s32'
                  onClick={() => {
                    window.open(config.socials?.instagram)
                  }}
                />}
                {config.socials?.linkedin && <i
                  className='icon icon--linkedin s32'
                  onClick={() => {
                    window.open(config.socials?.linkedin)
                  }}
                />}
                {config.socials?.youtube && <i
                  className='icon icon--youtube s32'
                  onClick={() => {
                    window.open(config.socials?.youtube)
                  }}
                />}
              </div>
            </div>}
          </div>

          <div className='footer__bottom'>
            <div className='footer__links'>
              <div
                className='--link'
                onClick={() => {
                  openPopup({ type: 'privacy' })
                }}>
                {t('privacy')}
              </div>
              <div
                className='--link'
                onClick={() => {
                  openPopup({ type: 'terms' })
                }}>
                {t('terms')}
              </div>
            </div>
            <div className='footer__copyright'>Copyright © {today.getFullYear()} {contact.companyName} {t('allRightsReserved')}</div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer